/* eslint-disable func-names */
/* eslint-disable object-shorthand */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';
import React, { Component } from 'react';
import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { formatGivenDate } from '../../../../shared/services/common-functions';

const showInf = value => {
    if ( Number( value ) > 99999 ) return 'Inf';
    return value;
};

function displayRow ( tempResult, maxPercent ) {

    if ( tempResult !== undefined && tempResult.forecastQty !== undefined ) {

        if ( ( tempResult.forecastQty === 0 ) ||
            ( tempResult.totalCap === 0 ) ) {

            return !( ( tempResult.maxQty === 9999999
                && tempResult.flexQty === 999999 ) );

        }
        const percent = ( ( ( tempResult.qtyOrderd / tempResult.totalCap ) * 100 ) + 0.49 );
        return !( percent < ( Number( maxPercent ) + 1 ) );

    }
    if ( tempResult !== undefined && tempResult.qtyOrderd !== undefined ) {

        return true;

    }
    return false;

}

const excelStyles = [
    {
        id: 'greenBackground',
        interior: {
            color: '#b5e6b5',
            pattern: 'Solid'
        }
    },
    {
        id: 'centerText',
        alignment: {
            horizontal: 'Center'
        }
    },
    {
        id: 'redFont',
        font: {
            fontName: 'Calibri Light',
            underline: 'Single',
            italic: true,
            color: '#ff0000'
        }
    },
    {
        id: 'oddRowBackground',
        interior: {
            color: '#f7f7f7',
            pattern: 'Solid'
        }
    },
    {
        id: 'boldBorders',
        borders: {
            borderBottom: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            },
            borderLeft: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            },
            borderRight: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            },
            borderTop: {
                color: '#000000',
                lineStyle: 'Continuous',
                weight: 3
            }
        }
    },
    {
        id: 'header',
        interior: {
            color: '#CCCCCC',
            pattern: 'Solid'
        },
        borders: {
            borderBottom: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            },
            borderLeft: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            },
            borderRight: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            },
            borderTop: {
                color: '#5687f5',
                lineStyle: 'Continuous',
                weight: 1
            }
        }
    },
    {
        id: 'dateFormat',
        dataType: 'dateTime',
        numberFormat: { format: 'mm/dd/yyyy;@' }
    },
    {
        id: 'twoDecimalPlaces',
        numberFormat: { format: '#,##0.00' }
    },
    {
        id: 'textFormat',
        dataType: 'string'
    },
    {
        id: 'bigHeader',
        font: { size: 25 }
    },
    {
        id: 'regularHeader',
        font: { size: 14 }
    }
];

class FamilyGroupAllocationToCapacityTable extends Component {

    onGridReady = params => {

        this.gridApi = params.api;

    }

    exportExcel = () => {

        const colKeys = this.gridApi.getAllGridColumns();
        const message = `*Only families and groups that have at least one week over ${this.props.red}% allocation are displayed.`;
        const title = 'Family and Group Capacity Allocation';
        const generalParams = {
            fileName: title,
            sheetName: 'Family and Group Capacity Allocation',
            exportMode: 'xlsx',
            columnKeys: colKeys,
            prependContent: [
                [],
                [
                    {
                        styleId: 'regularHeader',
                        data: {
                            type: 'String',
                            value: message
                        },
                        mergeAcross: 11
                    }
                ],
                []
            ]

        };

        this.gridApi.exportDataAsExcel( generalParams );

    };

    getColumnDefs = () => {

        const colDefs = [];

        colDefs.push(
            {
                field: 'family',
                headerName: 'Week Ending (Fiscal Month)',
                sortable: true,
                filter: true,
                width: 150,
                pinned: 'left',
                rowSpan: params => ( params.node.rowIndex % 2 === 0 ) ? 2 : 1,
                cellClassRules: {
                    'cell-span': params => params.value !== undefined,
                    'bkground-highlight': params => params.node.rowIndex % 4 === 0
                },
                cellRenderer: params => {

                    if ( params.value !== '' && params.value.includes( 'FAMILY' ) ) {

                        const cellVal = params.value.replaceAll( 'FAMILY', '' ).trim();
                        return (
                            <div>
                                <div>FAMILY</div>
                                <div>
                                    <Link to={`/${params.data.unitName}/order/availability?constrainttype=F&constraintkey=${cellVal}`}>{cellVal}</Link>
                                </div>
                            </div>
                        );

                    }
                    return ( <Link to={`/${params.data.unitName}/order/availability?constrainttype=G&constraintkey=${params.value}`}>{params.value}</Link> );

                }
            }
        );

        if ( this.props.lastWeeks ) {

            this.props.lastWeeks.forEach( weekObj => {

                const weekEnding = formatGivenDate( weekObj.weekEnding, 'YYYY-MM-DD' );
                const selectedWeekEnding = formatGivenDate( Number( this.props.selectedLastWeek ), 'YYYY-MM-DD' );

                if ( weekEnding === selectedWeekEnding ||
            new Date( weekEnding ) < new Date( selectedWeekEnding ) ) {

                    const dateVal = weekObj.weekEnding;
                    let headerName = `${formatGivenDate( Number( dateVal ), 'DDMMMYY' )}(${weekObj.monthNumber})`.toUpperCase();
                    const dateField = formatGivenDate( Number( dateVal ), 'YYYY-MM-DD' );

                    if ( dateField === '2000-01-01' ) {

                        headerName = 'Inventory';

                    } else if ( dateField === '2000-02-01' ) {

                        headerName = 'Rework';

                    }
                    colDefs.push(
                        {
                            headerName: `${headerName}`,
                            children: [
                                {
                                    field: `${Number( dateVal )}_Order`,
                                    headerName: 'Ord',
                                    sortable: true,
                                    filter: true,
                                    width: 70,
                                cellClassRules:
                        {
                            'bkground-highlight': params => params.node.rowIndex % 4 === 0 || params.node.rowIndex % 4 === 1,
                            'bkground-clear': params => params.node.rowIndex % 4 === 2 || params.node.rowIndex % 4 === 3
                        },
                                colSpan: params => {

                                    const timestamp = ( params.colDef.field ).split( '_' )[0];
                                    const dataObj = params.data;
                                    const timestampOrd = `${timestamp}_Order`;
                                    const timestampCap = `${timestamp}_Capacity`;
                                    if ( params.node.rowIndex % 2 === 0 ||
                                ( params.node.rowIndex % 2 !== 0
                                    && dataObj[timestampOrd] === undefined &&
                                    dataObj[timestampCap] === undefined ) ) {

                                        return 2;

                                    }
                                    return 1;

                                },
                                cellRenderer: params => {

                                    const timestamp = ( params.colDef.field ).split( '_' )[0];
                                    const dataObj = params.data;
                                    const timestamppercentage = `${timestamp}_Percentage`;
                                    const timestamporder = `${timestamp}_Order`;
                                    const timestampfcst = `${timestamp}_Forecast`;
                                    const timestampcap = `${timestamp}_Capacity`;

                                    if ( params.node.rowIndex % 2 === 0 ) {

                                        const percentage = dataObj[timestamppercentage] !== undefined ? `${dataObj[timestamppercentage]}` : '';
                                        if ( ( Number( dataObj[timestamppercentage] ) >
                                    Number( this.props.red )
                                    || dataObj[timestampcap] === 0
                                    || dataObj[timestampfcst] === 0 )
                                    && Number( percentage ) !== 0 ) {

                                            return <span className="red">{`${percentage}%`}</span>;

                                        }
                                        if ( ( Number( dataObj[timestamppercentage] ) <
                                    Number( this.props.blue ) &&
                                    !( dataObj[timestampfcst] === undefined
                                        && dataObj[timestamporder] !== undefined ) )
                                        && Number( percentage ) !== 0 ) {

                                            return <span className="blue">{`${percentage}%`}</span>;

                                        }
                                        if ( Number( percentage ) === 0 ) {

                                            return <span />;

                                        }
                                        return <span>{`${percentage}%`}</span>;

                                    }
                                    if ( ( params.node.rowIndex % 2 !== 0
                                && dataObj[timestamporder] === undefined
                                && dataObj[timestampfcst] === undefined ) ) {

                                        return '';

                                    }
                                    return ( <span>{dataObj[timestamporder] ? <Link to={`/${params.data.unitName}/constraints/check-orders-by-constraint-build-weeks?constrainttype=${params.data.ctype}&constraintkey=${params.data.ckey}&beginweek=${params.data.weekEnding}&endweek=${params.data.weekEnding}`}>{params.value}</Link> : ''}</span> );

                                }
                            },
                            {
                                field: `${Number( dateVal )}_Capacity`,
                                headerName: 'Cap',
                                sortable: true,
                                filter: true,
                                width: 70,
                                valueFormatter: params => showInf( params.value ),
                                cellRenderer: params => {

                                    if ( Number( params.value ) === 0 ) {

                                        return <span />;

                                    }
                                    return <span>{params.valueFormatted}</span>;

                                }
                            }
                        ]
                    }
                );

            }

        } );

        }

        return colDefs;

    };

    getTableResult = () => {

        const tableResult = [];

        if ( this.props.results && this.props.results.familyAvailabilityList ) {

            this.props.results.familyAvailabilityList.forEach( tempResult => {

                let showRecord = false;
                let nestedTableResult = {};
                nestedTableResult.family = `FAMILY ${tempResult.familyName}`;
                nestedTableResult.ctype = 'F';
                nestedTableResult.ckey = ( tempResult.familyName ).trim();
                nestedTableResult.weekEnding = formatGivenDate( Number( this.props.selectedLastWeek ), 'YYYY-MM-DD' );

                Object.keys( tempResult.familyMap ).forEach( item => {

                    if ( showRecord === true ||
                        displayRow( tempResult.familyMap[item], this.props.red ) ) {

                        showRecord = true;
                        nestedTableResult[`${item}_Order`] = tempResult.familyMap[item].qtyOrderd;

                        nestedTableResult[`${item}_Capacity`] = tempResult.familyMap[item].totalCap;

                        nestedTableResult[`${item}_Forecast`] = tempResult.familyMap[item].forecastQty;

                        nestedTableResult[`${item}_MaxQnty`] = tempResult.familyMap[item].maxQty;

                        nestedTableResult[`${item}_FlexQnty`] = tempResult.familyMap[item].flexQty;

                        if ( ( Number( nestedTableResult[`${item}_Capacity`] ) > 99999 ) || ( Number( nestedTableResult[`${item}_Forecast`] ) > 99999 ) ) {

                            nestedTableResult[`${item}_Percentage`] = 0;

                        } else if ( nestedTableResult[`${item}_Forecast`] !== undefined ) {

                            if ( nestedTableResult[`${item}_Capacity`] === 0 ) {

                                nestedTableResult[`${item}_Percentage`] = nestedTableResult[`${item}_Order`] * 100;

                            } else {

                                nestedTableResult[`${item}_Percentage`] = Math.round( ( ( nestedTableResult[`${item}_Order`] / nestedTableResult[`${item}_Capacity`] ) * 100 ) + 0.49 );

                            }

                        } else if ( nestedTableResult[`${item}_Order`] !== undefined ) {

                            nestedTableResult[`${item}_Percentage`] = nestedTableResult[`${item}_Order`] * 100;

                        } else {

                            nestedTableResult[`${item}_Percentage`] = undefined;

                        }

                    }

                } );

                if ( showRecord === true ) {

                    tableResult.push( nestedTableResult );
                    tableResult.push( nestedTableResult );

                }

                if ( tempResult.groupList ) {

                    tempResult.groupList.forEach( tempGrpResult => {

                    showRecord = false;
                    nestedTableResult = {};
                    nestedTableResult.family = tempGrpResult.groupName;
                    nestedTableResult.ctype = 'G';
                    nestedTableResult.ckey = ( tempGrpResult.groupName ).trim();
                    nestedTableResult.weekEnding = formatGivenDate( Number( this.props.selectedLastWeek ), 'YYYY-MM-DD' );

                    Object.keys( tempGrpResult.groupList ).forEach( item => {

                        if ( showRecord === true ||
                    displayRow( tempGrpResult.groupList[item], this.props.red ) ) {

                            showRecord = true;
                            nestedTableResult[`${item}_Order`] = tempGrpResult.groupList[item].qtyOrderd;

                            nestedTableResult[`${item}_Capacity`] = tempGrpResult.groupList[item].totalCap;

                            nestedTableResult[`${item}_Forecast`] = tempGrpResult.groupList[item].forecastQty;

                            nestedTableResult[`${item}_MaxQnty`] = tempGrpResult.groupList[item].maxQty;

                            nestedTableResult[`${item}_FlexQnty`] = tempGrpResult.groupList[item].flexQty;

                            if ( ( Number( nestedTableResult[`${item}_Capacity`] ) > 99999 ) || ( Number( nestedTableResult[`${item}_Forecast`] ) > 99999 ) ) {

                                nestedTableResult[`${item}_Percentage`] = 0;

                            } else if ( nestedTableResult[`${item}_Forecast`] !== undefined ) {

                                if ( nestedTableResult[`${item}_Capacity`] === 0 ) {

                                    nestedTableResult[`${item}_Percentage`] = nestedTableResult[`${item}_Order`] * 100;

                                } else {

                                    nestedTableResult[`${item}_Percentage`] = Math.round( ( ( nestedTableResult[`${item}_Order`] / nestedTableResult[`${item}_Capacity`] ) * 100 ) + 0.49 );

                                }

                            } else if ( nestedTableResult[`${item}_Order`] !== undefined ) {

                                nestedTableResult[`${item}_Percentage`] = nestedTableResult[`${item}_Order`] * 100;

                            } else {

                                nestedTableResult[`${item}_Percentage`] = undefined;

                            }

                        }

                    } );
                    if ( showRecord === true ) {

                        tableResult.push( nestedTableResult );
                        tableResult.push( nestedTableResult );

                    }

                } );

                }

            } );

        }

        const additionalInfo = { unitName: this.props.unitCode };
        const agGridResult = tableResult.map( i => ( { ...i, ...additionalInfo } ) );

        return agGridResult;

    };

    render () {

        const columnDefs = this.getColumnDefs();
        const tableResult = this.getTableResult();
        const { message } = this;
        return (
            <section className="atp-search-result-panel family-group-allocation-to-capacity-result-panel ">

                <div className="results-message">
                    {message}
                </div>

                <div key={`${this.props.red} ${this.props.blue}`} className="atp-ag-grid ag-theme-balham ag-theme-popupbg">
                    <AgGridReactComponent
                        reactNext={true}
                        suppressRowTransform={true}
                        columnDefs={columnDefs}
                        rowData={tableResult}
                        onGridReady={this.onGridReady}
                        headerHeight={45}
                        excelStyles={excelStyles}
                        overlayNoRowsTemplate={'<span style="padding: 10px; font-size: 14px;">No Rows To Show</span>'}
                    />
                </div>

            </section>
        );

    }

}

FamilyGroupAllocationToCapacityTable.propTypes = {
    results: PropTypes.object.isRequired,
    unitCode: PropTypes.string.isRequired,
    selectedLastWeek: PropTypes.string.isRequired,
    lastWeeks: PropTypes.array.isRequired,
    red: PropTypes.string.isRequired,
    blue: PropTypes.string.isRequired
};
export default FamilyGroupAllocationToCapacityTable;
